module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container\"> <div class=\"my-6 row\"> <div class=\"col-sm-8 mx-auto\"> <h3 class=\"text-center\">Email Verification</h3> <p>Automatically verifying your email by code, please wait...</p> <p>If there is an error, please reload the page or visit <a href=\"/verification\">the manual verification page</a> to enter the code by hand.</p> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/verification_submit/template.ejs
// module id = 1187
// module chunks = 1